import React, { useRef } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { CloudUploadOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { MAX_UPLOAD_MB } from '../../../shared/uploadLimits';

const PIIValidationDropzone = ({ disabled, onFilesAdded }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && e.dataTransfer.files) {
      onFilesAdded(e.dataTransfer.files);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClick = () => {
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleChange = (e) => {
    if (!disabled && e.target.files) {
      onFilesAdded(e.target.files);
      e.target.value = ''; // Reset input
    }
  };

  return (
    <Box
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
      sx={(theme) => ({
        border: '2px dashed',
        borderColor: 'divider',
        borderRadius: 3,
        p: 4,
        textAlign: 'center',
        mb: 2,
        bgcolor: 'background.paper',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          borderColor: disabled ? 'divider' : 'primary.main',
          bgcolor: disabled ? 'background.paper' : alpha(theme.palette.primary.main, 0.05),
        }
      })}
    >
      <Stack alignItems="center" spacing={1.5}>
        <CloudUploadOutlined sx={{ fontSize: 48, color: 'primary.main', opacity: 0.8 }} />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {t('PIIValidationDropzone.title', 'Kliknite alebo presuňte súbory sem')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {t('PIIValidationDropzone.subtitle', { defaultValue: 'Podporované formáty: PDF, DOCX · najviac {{limit}} MB na súbor', limit: MAX_UPLOAD_MB })}
          </Typography>
        </Box>
      </Stack>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept=".pdf,.docx"
        style={{ display: 'none' }}
        onChange={handleChange}
        disabled={disabled}
      />
    </Box>
  );
};

export default PIIValidationDropzone;